<template>
  <footer class="mt-auto flex w-full flex-col">
    <div class="flex justify-center bg-blue-50">
      <div class="p-lg max-w-content flex items-center">
        <img
          src="~/assets/images/illustrations/app-mockup-3d.png"
          alt=""
          width="205"
          class="max-laptop:hidden"
        />

        <div class="flex flex-col">
          <p class="text-large font-semibold text-gray-600">
            Téléchargez notre application
          </p>
          <p class="mt-md text-h1 text-blue-500">
            Vos sorties et événements locaux toujours à portée de main
          </p>

          <div class="gap-lg mt-md flex flex-wrap items-center justify-center">
            <NuxtLink
              to="https://play.google.com/store/apps/details?id=com.sopheos.agenda&utm_source=org&utm_medium=referral&utm_campaign=app_install&utm_content=footer"
              rel="noopener noreferrer"
              target="_blank"
            >
              <img
                src="~/assets/images/google-play.png"
                :alt="`Télécharger l'application Agenda.org sur GooglePlay - ouvre une nouvelle fenêtre`"
                class="h-10 w-33"
              />
            </NuxtLink>

            <NuxtLink
              to="https://apps.apple.com/fr/app/apple-store/id6793108859?pt=96893923&ct=app_install_org_footer&mt=8"
              rel="noopener noreferrer"
              target="_blank"
            >
              <img
                src="~/assets/images/app-store.png"
                :alt="`Télécharger l'application Agenda.org sur AppStore - ouvre une nouvelle fenêtre`"
                class="h-10 w-33"
              />
            </NuxtLink>
          </div>
        </div>
      </div>
    </div>

    <div
      class="gap-sm laptop:flex-row laptop:gap-xxl laptop:items-end p-lg laptop:justify-center flex flex-col justify-end"
    >
      <div class="flex items-center justify-center">
        <GLink to="/cgu">Conditions générales d'utilisation</GLink>
      </div>
      <div class="flex items-center justify-center">
        <GLink to="/confidentialite">Politique de confidentialité</GLink>
      </div>
      <div class="flex items-center justify-center">
        <GLink to="https://info.agenda.org/"> Nous contacter </GLink>
      </div>
    </div>
  </footer>
</template>
